module.exports = __webpack_public_path__ + "static/media/plastic.22d49360.svg";